import {MyopMessageKey} from "./MyopMessages";
import {BaseMyopMessage, MyopBindMessage, MyopBindReplayMessage} from "../messages";
import {CleanupHandler} from "./index.ts";

export type IMessageExecutorCleanup = CleanupHandler | Promise<CleanupHandler> | Promise<void> | void;

export const runExecutorCleanup = async (task: IMessageExecutorCleanup) => {
    if (typeof task === 'function') {
        // It's a function, call it
        task();
    } else if (task instanceof Promise) {
        // It's a Promise, await it
        const result = await task;

        if (typeof result === 'function') {
            // If the result is a function, call it
            result();
        }
    }
    // If task is void, do nothing
}

type IMessageExecutor<T extends BaseMyopMessage> = (message: T) => IMessageExecutorCleanup;

interface IMessageHandler<T extends BaseMyopMessage> {
    messageType: MyopMessageKey

    executor: IMessageExecutor<T>;

    messageToHost: (message: MyopBindReplayMessage, replayTo?: MyopBindMessage) => void;
}

export abstract class BaseMessageHandler<T extends BaseMyopMessage = any> implements IMessageHandler<T> {

    //TODO : add dispose method

    constructor(public messageToHost: (message: MyopBindReplayMessage, replayTo?: MyopBindMessage) => void) {

    }

    abstract messageType: MyopMessageKey
    abstract executor: IMessageExecutor<T>;
}

export abstract class BaseContextMessageHandler<T extends BaseMyopMessage = any, E = any> extends BaseMessageHandler<T> {
    constructor(public messageToHost: (message: MyopBindReplayMessage, replayTo?: MyopBindMessage) => void, public context?: E) {
        super(messageToHost);
    }
}
